import { Box } from "@chakra-ui/react";

export const InnerBox = (props: any): JSX.Element =>
  <Box
    pt={6} pb={2} pr={6} pl={6}
    {...props}
  />;